(function(){
  document.querySelectorAll('[data-product-section]').forEach(function(section) {
    if(section.dataset.physicalInitialized)return;section.dataset.physicalInitialized='true';
    var form = section.querySelector('[data-product-form]');
    var fallback = section.querySelector('[data-variant-fallback]');
    var choices = section.querySelector('[data-variant-options]');
    if (!form || !fallback || !choices) return;
    var id = form.querySelector('[data-variant-id]');
    var button = form.querySelector('[data-product-add]');
    var price = section.querySelector('[data-product-price]');
    var status = section.querySelector('[data-product-status]');
    var groups = [].slice.call(form.querySelectorAll('[data-option-position]'));
    var variants;
    try {
      variants = [].slice.call(choices.options).map(function(option) {
        return { id: option.value, options: JSON.parse(option.dataset.options), price: option.dataset.price, available: option.dataset.available === 'true', imageId: option.dataset.imageId };
      });
    } catch (_) { return; }
    if (!id || !button || !price || !status || !variants.length || Number(choices.dataset.variantCount) > variants.length) return;
    function resolve() {
      if (!groups.length) return variants.find(function(v) { return v.id === id.value; });
      var values = groups.map(function(group) { var checked = group.querySelector('[data-physical-option]:checked'); return checked && checked.value; });
      return variants.find(function(v) { return v.options.length === values.length && v.options.every(function(value, index) { return value === values[index]; }); });
    }
    function update(variant, changeUrl) {
      id.value = variant ? variant.id : '';
      id.disabled = !variant || !variant.available || section.dataset.launchReady !== 'true';
      button.disabled = id.disabled;
      var hidePrice = section.dataset.priceApproved !== 'true';
      price.hidden = hidePrice;
      price.textContent = !hidePrice && variant ? variant.price : '';
      button.textContent = !variant ? button.dataset.unavailableLabel : variant.available && !hidePrice ? button.dataset.addLabel + ' — ' + variant.price : button.dataset.soldOutLabel;
      status.textContent = variant ? variant.options.join(' / ') + (hidePrice ? '' : ' · ' + variant.price) + ' · ' + (variant.available ? button.dataset.availableLabel : button.dataset.soldOutLabel) : button.dataset.unavailableLabel;
      if (changeUrl) {
        var url = new URL(window.location.href);
        url.searchParams.delete('option_values');
        if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant');
        window.history.replaceState(window.history.state, '', url);
      }
      var gallery = section.querySelector('.pdp__gallery');
      if (gallery) gallery.dispatchEvent(new CustomEvent('met:variant-image', { detail: { imageId: variant && variant.imageId } }));
      form.dispatchEvent(new CustomEvent('met:variant-change', { bubbles: true, detail: { variantId: variant ? variant.id : null, available: !!(variant && variant.available), physicalOptions: variant ? variant.options.slice() : [] } }));
    }
    var selected = variants.find(function(v) { return v.id === id.value; });
    groups.forEach(function(group, index) { group.querySelectorAll('[data-physical-option]').forEach(function(input) { input.checked = !!selected && input.value === selected.options[index]; }); });
    form.querySelector('[data-option-chips]').hidden = false;
    fallback.hidden = true;
    form.addEventListener('change', function(event) { if (event.target.matches('[data-physical-option]')) update(resolve(), true); });
    form.addEventListener('submit', function(event) {
      var variant = resolve();
      if (!variant || !variant.available || id.disabled || id.value !== variant.id) { event.preventDefault(); update(variant, false); }
    });
    section.addEventListener('met:gallery-ready', function() { update(selected, false); }, { once: true });
    update(selected, false);section.dataset.controlsReadyMs=String(Math.round(performance.now()));
  });

})();
